import { MetadataFieldDefinitionLogicBase } from './metadata-field-def-logic-base';

export class FavoriteFieldDefLogic extends MetadataFieldDefinitionLogicBase {
    public constructor() {
        super('Favorite');
    }
}
